import moment, { Moment } from 'moment';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import './schedule-form.scss';
import { ReportType } from 'types/report';
import api from 'api';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import {  SECTION_SCHEDULE_LIST } from '../report-modal';

function ScheduleForm({
    report,
    setSection
} : {
    report: ReportType,
    setSection: (data: number) => void
}) {
    const state = useSelector((state: RootState) => state);
    const [loading, setLoading] = useState<boolean>(false);
    const [dateNextSend, setDateNextSend] = useState<Moment>(moment().subtract(1, 'd').set('h', 0).set('m', 0).set('s', 0));
    const [frequencyId, setFrequencyId] = useState(1);
    
    const { handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async (data:any) => {
        // console.log("report", report);
        // console.log("dateNextSend", dateNextSend);
        // console.log("frequencyId", frequencyId);

        var request = {
            ReportId : report.Id,
            DateNextSend : dateNextSend.format("DD MMM YYYY HH:mm"),
            FrequencyId : frequencyId
        }
        // console.log("API Call Schedule: ", request);
        setLoading(true);
        await api.report.schedule(request)
        .then((data: { success: any; ok: any}) => {
            if (data.success || data.ok) {
                toast.success("Report successfully scheduled"); return; 
            } else {
                toast.error("Error generating report"); return; 
            }
        }).catch(err => {
            toast.error(err.toString());
        })
        .finally(() =>{
            setLoading(false);
            setSection(SECTION_SCHEDULE_LIST);
        })       
        if (errors) {
            toast.warn(errors);
        }   
    }

    const quickSelectDates = [
        {
            Id: 1,
            Description: "Today",
            Moment: moment().set('hours', 0).set('minutes', 0).set('seconds', 0)
        },
        {
            Id: 2,
            Description: "Tomorrow",
            Moment: moment().add(1, 'day').set('hours', 8).set('minutes', 0).set('seconds', 0)
        },
        {
            Id: 3,
            Description: "Next Monday",
            Moment: moment().add(1, 'week').set('day', 1).set('hours', 8).set('minutes', 0).set('seconds', 0)
        },
        {
            Id: 4,
            Description: "Next Friday",
            Moment: moment().add(1, 'week').set('day', 5).set('hours', 8).set('minutes', 0).set('seconds', 0)
        },
        {
            Id: 5,
            Description: "1st Day of the Month",
            Moment: moment().startOf('month').add(1, 'month').set('hours', 8).set('minutes', 0).set('seconds', 0)
        },
        {
            Id: 6,
            Description: "Last Day of Month",
            Moment: moment().endOf('month').set('hours', 8).set('minutes', 0).set('seconds', 0)
        }
    ];

    // useEffect(() => {
    //     console.log("dateNextSend: ", dateNextSend);
    // }, [dateNextSend]);

    return (        
        <div id={'schedule-form'} className="form-container">
            <h2>{'SCHEDULE'}</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h4>Summary</h4>
                <div className='summary'>
                    <div>
                        Report Name: {report.Name}
                    </div>
                    <div>
                        Project Id(s): {report.BinIds.toString()}
                    </div>
                    <div>
                        Streams: 
                        <ul>
                            {state.core.Stream.filter(x => report.StreamIds.includes(x.Id)).map((item, idx) => {
                                return <li key={idx}>{item.Description}</li>
                            })}
                        </ul>
                    </div>
                    <div>
                        Templates: 
                        <ul>
                            {state.reportOptions.TemplateOptions.filter(x => report.TemplateIds.includes(x.Id)).map((item, idx) => {
                                return <li key={idx}>{item.Name}</li>
                            })}
                        </ul>
                    </div>
                    <div>
                        Contacts: 
                        <ul>
                            {state.clientContacts.filter(x => report.RecipientIds.includes(x.Id)).map((item, idx) => {
                                return <li key={idx}>{item.Name}</li>
                            })}
                        </ul>
                    </div>
                    <div>
                        Layout: {state.reportOptions.LayoutOptions.find(x => x.Id === report.LayoutId)?.Description}
                    </div>
                </div>

                <div className='input-group date'>
                    <label> Next Send </label>
                    <input type="datetime-local" value={dateNextSend.format("YYYY-MM-DD[T]hh:mm")} onChange={e => setDateNextSend(moment(e.currentTarget.value))} />
                
                    <div className="quick-dates">
                        {quickSelectDates.map((item, idx) => {
                            return <span key={idx} onClick={() => setDateNextSend(item.Moment)} >{item.Description}</span>
                        })}
                    </div>
                </div>
                
                        
                <div className="input-group">
                    <label> Frequency </label>
                    <select defaultValue={frequencyId} onChange={(e) => setFrequencyId(parseInt(e.currentTarget.value))}>
                        <option value="" disabled selected>Select Frequency</option>
                        {state.reportOptions.FrequencyOptions.map((item, idx) => {
                            return <option key={idx} value={item.Id}>{item.Description}</option>
                        })}
                    </select>
                </div>

                <button className="button" type="submit">{loading ? <i className="fal fa-spinner fa-spin"></i> : <span>SUBMIT</span> }</button>
            </form>
        </div>
    )
}

export default ScheduleForm;